module.exports = __webpack_public_path__ + "img/center-on-01.37d83355.jpg";